import React from "react"
import _ from 'lodash';
import { connect } from "react-redux"
@connect((store) => {
    return {
        socket: store.socket.container,
        notes: store.notes,
        loggedUser: store.loggedUser,
        project: store.project,
        conversations: store.conversations,
        conversation: store.conversation
    }
})
export default class Socket extends React.Component {
    constructor(props) {
        super(props)
        this.getCurrentProps = this.getCurrentProps.bind(this)
    }

    UNSAFE_componentWillMount() {
        const { socket, dispatch, loggedUser } = this.props;
        const user = loggedUser.data
        socket.on('connect',()=>{
            console.log("connected id:",socket.id)
            socket.emit('room', "EVdqi7Nv2REPNB248i1Y2NZziNNWShLUPyDggg1gkKF1");
          
        })
        socket.on("connect_error", () => {
           console.log("socket io disconnected")
            socket.connect();
          });
       
        socket.on("FRONT_NEW_NOTE", (data) => {
            const { notes, project, conversation } = this.getCurrentProps()
            const projectManagerId = project.Selected.leadId
            const isAdmin = user.userRole < 3 || user.id === projectManagerId
            const members = data.tagged_users.filter(f => f.linkId === user.id)
            if (user.id !== data.createdBy && (isAdmin || members.length > 0) && project.Selected.id === data.project.id) {
                const list = notes.List
                const updated = _.uniqBy([{ ...data, unread: 1 }, ...list], 'id')
                const count = conversation.ConversationCount
                dispatch({ type: "SET_NOTES_LIST", list: updated });
                dispatch({ type: "SET_CONVERSATION_COUNT", count: count + 1 })

            }
        })
        socket.on("FRONT_UPDATE_NOTE", (data) => {
            const { notes, project, conversations } = this.getCurrentProps()
            const projectManagerId = project.Selected.leadId
            const wsLead = data.wsLead.indexOf(user.id) > -1
            const isAdmin = user.userRole < 3 || user.id === projectManagerId || wsLead
            const members = data.tagged_users.filter(f => f.linkId === user.id)
            if (project.Selected.id === data.project.id) {
                if ((isAdmin || members.length > 0)) {
                    const list = notes.List
                    let isExist = false
                    let updated = list.map(l => {
                        if (l.id === data.id) {
                            l = { ...data, unread: l.unread }
                            isExist = true
                        }
                        return l
                    })
                    if(!isExist) {
                        updated=[...[data], ...list]
                    }
                    dispatch({ type: "SET_NOTES_LIST", list: updated });
                  
                } else {
                    if(conversations.selected.id !== data.id) {
                        dispatch({ type: "SET_NOTES_LIST", list: notes.List.filter(l=>l.id !== data.id) })  
                    } 
            
                }
                if(conversations.selected.id ===  data.id) {
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: data });
                }
               
                
            }
        })
        socket.on("FRONT_ARCHIVED_NOTE", (data) => {
            const { notes, project, conversations } = this.getCurrentProps()
            const projectManagerId = project.Selected.leadId
            const isAdmin = user.userRole < 3 || user.id === projectManagerId
            const members = data.tagged_users.filter(f => f.linkId === user.id)
            if (project.Selected.id === data.project.id) {
                if (isAdmin || members.length > 0) {
                    if (conversations.selected && conversations.selected.id === data.id) {
                        dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: { ...conversations.selected, isArchived: data.isArchived } })
                    }
                    const path = window.location.href.replace(/^.*[\\\/]/, '')
                    const onConversation = path === 'conversations'
                    let updated = notes.List
                    if (onConversation) {
                        if(data.updateBy === user.id || !conversations.selected.id){
                            if (["favorites", "archived"].indexOf(notes.Type) === -1) {
                                updated = data.isArchived ? updated.filter(u => u.id !== data.id) : [data, ...updated]
                            } else if (notes.Type === 'archived') {
                                updated = data.isArchived ? [data, ...updated] : updated.filter(u => u.id !== data.id)
                            }
                         }           
                    }
                    let count = notes.TotalCount
                    if (data.isArchived) {
                        count--
                    }
                    dispatch({ type: "SET_NOTES_ALL_COUNT", count: count });
                    dispatch({ type: "SET_NOTES_LIST", list: _.uniqBy(updated,'id') });

                }
            }
        })

        socket.on("FRONT_COMMENT_LIST", ({ result, members, fromEmail }) => {
            const { conversations, notes, note, conversation, project } = this.getCurrentProps();
            const userMembers = members.filter(f => f === loggedUser.data.id);
            if (userMembers.length > 0 && project.Selected.id === result.conversationNotes.projectId) {
                if (conversations.selected && conversations.selected.id === result.linkId) {
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: _.uniqBy([...conversations.selectedMessages, result],'id')});

                    const hasNew = conversations.selectedEvents.filter(f => f.event === "New Message")
                     if (loggedUser.data.id !== result.usersId ||fromEmail) {
                        if (hasNew.length === 0) {
                            let newEvent = {
                                dateAdded: result.dateAdded,
                                dateUpdated: result.dateAdded,
                                event: "New Message",
                                isDeleted: 0,
                                notesId: result.linkId,
                                projectId: project.Selected.id
                            }
                            const events = [...conversations.selectedEvents, newEvent]
                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: events });
                        }

                        const unread = conversations.selected.unread
                        dispatch({
                            type: "UPDATE_CONVERSATIONS_SELECTED", selected: {
                                ...conversations.selected,
                                notesTagDoc: [...conversations.selected.notesTagDoc, ...result.conversationDocuments],
                                unread: unread + 1
                            }
                        });
                        setTimeout(() => {
                            const ht = $('#divElement').prop('scrollHeight')
                            $('#divElement').animate({
                                scrollTop: ht + 500
                            }, 2000);

                        }, 100);

                     }
                  

                }
                if (note) {
                    const noteCount = note.unread
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: { ...note, unread: noteCount + 1 } });
                }

                let currentCount = 0
                if (notes.List.length) {

                    const current = notes.List.filter(n => n.id === result.linkId)
                    currentCount = current[0].unread > 0 ? currentCount + 1 : 0
                    const sortList = notes.List.map(n => {
                        if (n.id === result.linkId) {
                            return {
                                ...n,
                                comments: [result],
                                notesTagDoc: [...n.notesTagDoc, ...result.conversationDocuments],
                                ...(loggedUser.data.id !== result.usersId ? { unread: currentCount + 1 } : {})
                            }
                        }

                        return n;
                    })
                    dispatch({
                        type: "SET_NOTES_LIST",
                        list: [...sortList.filter(s => s.id === result.linkId), ...sortList.filter(s => s.id !== result.linkId)],
                        count: notes.Count
                    });
                }

                const count = conversation.ConversationCount
                if (notes.List.length > 0 && currentCount < 1 && loggedUser.data.id !== result.usersId) {
                    dispatch({ type: "SET_CONVERSATION_COUNT", count: count < 0 ? 1 : count + 1 })
                }
            }
        })

        socket.on("FRONT_COMMENT_DELETE_FILE", (data) => {
            const { conversations, notes, project } = this.getCurrentProps();
            const projectManagerId = project.Selected.leadId
            const isAdmin = user.userRole < 3 || user.id === projectManagerId
            const members = data.conversationNotes.tagged_users.filter(f => f.linkId === user.id)
            const docSelected = parseInt(data.docId)
            if (project.Selected.id === data.conversationNotes.projectId) {
                if ((isAdmin || members.length > 0) && conversations.selected && conversations.selected.id === data.linkId) {
                    const messages = conversations.selectedMessages.map(m => {
                        const doc = m.conversationDocuments.map(d => {
                            if (d.document.id === docSelected) {
                                return {
                                    ...d,
                                    isDeleted: 1
                                }
                            } else {
                                return {
                                    ...d
                                }
                            }
                        })
                        return {
                            ...m,
                            conversationDocuments: doc
                        }
                    })
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: messages });
                    //update selected
                    const selected = conversations.selected
                    selected.notesTagDoc = selected.notesTagDoc.filter(f => f.document.id !== docSelected)
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: selected });
                }

                const sortList = notes.List.map(n => {
                    if (n.id === conversations.selected.id) {
                        return {
                            ...n,
                            notesTagDoc: n.notesTagDoc.filter(f => f.document.id !== docSelected)
                        }
                    }

                    return n;
                })
                //update note list
                dispatch({
                    type: "SET_NOTES_LIST",
                    list: sortList
                });
                dispatch({ type: "SET_CONVERSATIONS_FILE_SELECTED", selected: {} });
            }
        })

        socket.on("FRONT_COMMENT_EDIT", ({ data }) => {
            const { conversations, notes, note, conversation, project } = this.getCurrentProps();
            const projectManagerId = project.Selected.leadId
            const isAdmin = user.userRole < 3 || user.id === projectManagerId
            const members = data.conversationNotes.tagged_users.filter(f => f.linkId === user.id)
            if (project.Selected.id === data.conversationNotes.projectId) {
                const message = _.omit(data, ['conversationNotes'])
                if ((isAdmin || members.length > 0) && conversations.selected && conversations.selected.id === data.linkId) {

                    const selected = conversations.selectedMessages.map(s => {
                        if (s.id === data.id) {
                            return {
                                ...s,
                                ...message
                            }
                        } else {
                            if(s.parent && (s.parent.id === data.id)) {
                                return{...s,parent:message }
                            }
                            return s
                        }
                    })
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selected })
                }
                const sortList = notes.List.map(n => {
                    if (n.id === data.linkId) {
                        return {
                            ...n,
                            comments: [message]
                        }
                    }

                    return n;
                })
                //update note list
                dispatch({
                    type: "SET_NOTES_LIST",
                    list: sortList
                });
            }
        })
        socket.on("FRONT_COMMENT_DELETE", (data) => {
            const { conversations, notes, project } = this.getCurrentProps();
            const projectManagerId = project.Selected.leadId
            const isAdmin = user.userRole < 3 || user.id === projectManagerId
            const members = data.conversationNotes.tagged_users.filter(f => f.linkId === user.id)
            if (project.Selected.id === data.conversationNotes.projectId) {
                let message = _.omit(data, ['conversationNotes'])

                if ((isAdmin || members.length > 0) && conversations.selected && conversations.selected.id === data.linkId) {
                    const selected = conversations.selectedMessages.map(s => {
                        if (s.id === data.id) {
                            return {
                                ...s,
                                ...message
                            }
                        } else {
                            if(s.parent && (s.parent.id === data.id)) {
                                return{...s,parent:message}
                            }
                            return s
                        }
                    })
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selected })
                    const selectedConv = conversations.selected
                    selectedConv.notesTagDoc = selectedConv.notesTagDoc.filter(f =>  data.docDeleted.indexOf(f.document.id) ===-1)
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: selectedConv });
                }
                const sortList = notes.List.map(n => {
                    if (n.id === data.linkId) {
                        return {
                            ...n,
                            comments: [message]
                        }
                    }

                    return n;
                })
                //update note list
                dispatch({
                    type: "SET_NOTES_LIST",
                    list: sortList
                });

            }
        })


        socket.on("FRONT_COMMENT_REMOVE_USER", ({ result, members }) => {
            const { conversations, notes, note, conversation, project } = this.getCurrentProps();
        })
    }
    getCurrentProps() {
        return this.props;
    }
    render() { return <div> </div> }
}